export const fr = {
  // Header
  header: {
    contact: "Contact",
    services: "Services",
    servicesDropdown: {
      flexibleWorkstations: "Postes de travail flexibles",
      privateOffices: "Bureaux privés",
      meetingRooms: "Salles de réunion",
      commonSpaces: "Espaces communs"
    }
  },

  // Homepage
  home: {
    title: "Votre espace de travail, ",
    title2: "votre inspiration ",
    subtitle: "Un coworking moderne en France, pensé pour stimuler la créativité, la collaboration et la productivité.",
    reserveButton: "Réservez maintenant",
    gallery: {
      rotateHint: "Tournez votre appareil pour une meilleure expérience de visualisation"
    }
  },

  // Contact Page
  contact: {
    title: "Contactez-Nous",
    form: {
      name: "Nom & Prénom",
      namePlaceholder: "Votre nom",
      email: "Email",
      emailPlaceholder: "Votre email",
      phone: "Téléphone",
      phonePlaceholder: "Votre téléphone",
      message: "Message",
      messagePlaceholder: "Votre message",
      submit: "Envoyer"
    },
    info: {
      title: "Informations de Contact",
      phone: "06 88 61 58 11",
      email: "contact@spotin-france.fr",
      address: "54 rue du Général de Gaulle, Belhomert-Guéhouville, France, 28240"
    },
    success: "✅ Message envoyé avec succès !",
    error: "❌ Erreur lors de l'envoi du message.",
    networkError: "📡 Impossible d'envoyer le message."
  }
};
